// components/Notification.js
import React, { useEffect } from 'react';
import MDAlert from 'ui/MDAlert';
import MDTypography from 'ui/MDTypography';

const Notification = ({ notification, setNotification }) => {
  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => {
        setNotification(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [notification, setNotification]);

  return (
    notification && (
      <MDAlert color={notification.type} mt="20px">
        <MDTypography variant="body2" color="white">
          {notification.message}
        </MDTypography>
      </MDAlert>
    )
  );
};

export default Notification;
